// extracted by mini-css-extract-plugin
export default {"DisclaimerText":"DisclaimerText_DisclaimerText__GVEJ8"};